import { FC } from 'react';
import { CheckboxProps, Checkbox } from './Checkbox';
import { cn } from '@fe-learner-common';
interface LabeledCheckboxProps extends CheckboxProps {
  label: string;
}

export const LabeledCheckbox: FC<LabeledCheckboxProps> = ({
  className,
  checked,
  label,
  id,
  onChange,
  size,
}) => {
  const handleOnChange = () => {
    onChange();
  };

  return (
    <label
      className={cn(
        'flex h-12 cursor-pointer select-none items-center gap-3.5 rounded-lg px-3 py-3.5 hover:bg-neutral-100',
        className,
      )}
      onClick={(event) => {
        event.preventDefault();

        handleOnChange();
      }}
      htmlFor={id}
    >
      <Checkbox size={size} checked={checked} id={id} onChange={onChange} />
      <span
        className={cn('cursor-pointer text-title-sm first-letter:capitalize', {
          'text-neutral-500': !checked,
        })}
      >
        {label}
      </span>
    </label>
  );
};
